<template>
  <div class="home">
    <nav class="navbar is-transparent">
      <div id="navbar-top" class="navbar-menu">
        <div class="navbar-start">
        </div>
        <div class="navbar-end">
          <div class="navbar-item">
            <div class="field is-grouped">
              <p class="control">
                <button v-show="isHost && false" class="button" @click="openModelCreateSharedGame()">
                  <span>{{ $t('game.createSharedGame')}}</span>
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <div class="page-title has-text-centered">
            <b-title is-1>{{ $t('message.totWasted') }}</b-title>
          </div>
          <div v-if="!this.sharedSessionUri">
            <swiper :options="swiperOptions" ref="mySwiper">
              <!-- slides -->
              <swiper-slide
                  v-for="card in cards[cardLanguage]" :key="card.id">
                <b-card id="card-stage">
                  <b-card-header>
                    <div :class="getCardTitleClass(card.category.replace('.', '-'))">
                      {{ $t('page.' + card.category) }}
                    </div>
                  </b-card-header>
                  <b-card-content>
                    <b-title is-3>
                      {{ card.rule}}
                    </b-title>
                    <b-title is-4>
                      {{ card.ruleComment}}
                    </b-title>
                  </b-card-content>
                  <b-card-footer>
                    <p class="card-footer-item">
                <span>
                  <b-title is-5>{{ $t('page.clickToGoNext') }}</b-title>
                </span>
                    </p>
                  </b-card-footer>
                </b-card>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper-slide>
            </swiper>
          </div>
          <div v-if="this.sharedSessionUri">
            <div  v-if="sharedSessionCard.category == null">
              <b-card id="card-stage-fixed">
                <b-card-content>
                  <b-title is-3 class="has-text-centered">
                    {{ $t('message.waitingHostCard')}}
                  </b-title>
                </b-card-content>
              </b-card>
            </div>
            <div v-else>
              <b-card id="card-stage-fixed">
                <b-card-header>
                  <div :class="getCardTitleClass(sharedSessionCard.category.replace('.', '-'))">
                    {{ $t('page.' + sharedSessionCard.category) }}
                  </div>
                </b-card-header>
                <b-card-content>
                  <b-title is-3 class="has-text-centered">
                    {{sharedSessionCard.rule}}
                  </b-title>
                  <b-title is-4 class="has-text-centered">
                    {{sharedSessionCard.ruleComment}}
                  </b-title>
                </b-card-content>
                <b-card-footer>
                  <p class="card-footer-item">
                <span>
                  <b-title is-5><a href="/">{{ $t('page.quitSharedSession') }}</a></b-title>
                </span>
                  </p>
                </b-card-footer>
              </b-card>
            </div>
            <div class="swiper-pagination" slot="pagination"></div>
          </div>
        </div>
      </div>
    </section>
    <shared-game :site-url="getSiteUrl" :first-card="getDefaultCard" ref="sharedGameModal"></shared-game>
  </div>
</template>

<script>
// @ is an alias to /src
import '@/assets/scss/main.scss'
import enCards from '@/assets/data/drinkCards/en.cards.js'
import ptCards from '@/assets/data/drinkCards/pt.cards.js'
import frCards from '@/assets/data/drinkCards/fr.cards.js'
import Footer from '@/components/partials/Footer.vue'
import SharedGame from '@/components/partials/SharedGame.vue'
import 'swiper/dist/css/swiper.css'
import axios from 'axios'

import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'game',
  components: {
    swiper,
    swiperSlide,
    Footer,
    SharedGame
  },
  data: function () {
    return {
      apiClient: null,
      cardIndex: 0,
      cardLanguage: 'en',
      cards: {
        en: enCards,
        pt: ptCards,
        fr: frCards
      },
      modals: {
        sharedGame: false
      },
      isHost: true,
      sharedSessionUri: null,
      sharedSessionCard: {
        category: null,
        rule: null,
        ruleComment: null
      }
    }
  },
  computed: {
    getApiClient: function () {
      if (this.apiClient === null) {
        this.apiClient = axios.create({
          baseURL: this.getApiUrl,
          timeout: 10000,
          headers: {
            'X-Custom-Header': 'foobar'
          }
        })
      }
      return this.apiClient
    },
    getApiUrl: function () {
      return 'https://totally-wasted-api-prod.azurewebsites.net/game'
    },
    getSiteUrl: function () {
      return 'https://green-pond-0847e8a03.azurestaticapps.net/game/' + this.cardLanguage
    },
    getActiveCard: function () {
      return this.cards[this.cardLanguage][this.$refs.mySwiper.swiper.activeIndex]
    },
    getGameSession: function () {
      const data = this.$refs.sharedGameModal.getSessionDetails()
      if (typeof data.uri === 'undefined') {
        return null
      }
      return data
    },
    getDefaultCard () {
      return this.cards[this.cardLanguage][0].id
    },
    swiperOptions: function () {
      return {
        autoHeight: true,
        roundLengths: true,
        grabCursor: true,
        spaceBetween: 5
      }
    }
  },
  methods: {
    getCardTitleClass (category) {
      return 'card-category is-' + category
    },
    getNextCard () {
      alert('get next card')
      if (this.cardIndex + 1 === this.cards[this.cardLanguage].length) {
        this.cardIndex = -1
      }
      this.cardIndex++
    },
    openModelCreateSharedGame () {
      this.$refs.sharedGameModal.openModal()
    },
    shuffleArray (array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]]
      }
    },
    onSlideChange () {
      if (this.isHost && this.getGameSession) {
        // update game session with active card
        this.getApiClient.post(`/sessions/${this.getGameSession.uri}`, {
          nextid: '' + this.getActiveCard.id
        },
        {
          headers: { Authorization: this.getGameSession.clientAuthToken }
        }
        )
          .then((response) => {
            // all good here
          }).catch(function (error) {
            console.log(error)
          })
      }
    },
    startHostedGame () {
      var self = this
      this.getApiClient.get(`/sessions/${this.sharedSessionUri}`)
        .then((response) => {
          var card = response.data
          var localCard = this.cards[this.cardLanguage].find(function (c) {
            if (typeof card === 'object') {
              if (card.currentCard.toString() === c.id.toString()) {
                return c
              }
            }
          })
          self.sharedSessionCard = localCard
        })
    }
  },
  created () {
    this.cardLanguage = this.$route.params.lang
    this.sharedSessionUri = this.$route.params.sharedGameUri

    if (!this.sharedSessionUri) {
      this.shuffleArray(this.cards[this.cardLanguage])
      this.shuffleArray(this.cards[this.cardLanguage])
      this.shuffleArray(this.cards[this.cardLanguage])
    }

    // todo: get better suffle function
  },
  mounted () {
    if (this.sharedSessionUri) {
      this.isHost = false
      this.$refs.sharedGameModal.closeModal()
      setInterval(this.startHostedGame, 1500)
    }

    // if I change slide
    this.$refs.mySwiper.swiper.on('slideChange', this.onSlideChange)
  }
}
</script>
